<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑申请信息"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto',minWidth: form_min_width,}" autocomplete="off">
            <el-form-item label="姓名">
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入姓名" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input type="text" v-model="ruleForm.mobile" maxlength="11" placeholder="请输入手机号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="用户类型">
                <el-select  v-model="ruleForm.type"
                    placeholder="请选择用户类型"
                    style="width:100%;" @change="createParams()">
                    <el-option
                        v-for="item in allType"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="性别">
                <el-radio-group v-model="ruleForm.sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="年龄">
                <el-input type="text" v-model="ruleForm.age" placeholder="请输入年龄" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="单位" prop="company_name">
                <el-select
                    filterable
                    allow-create
                    default-first-option
                    v-model="ruleForm.company_name" placeholder="请选择/输入单位"
                            style="width:100%;">
                    <el-option
                        v-for="item in allCompany"
                        :key="item.company_name"
                        :label="item.company_name"
                        :value="item.company_name"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="职务">
                <el-input type="text" v-model="ruleForm.position" placeholder="请输入职务" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="科室" v-if="ruleForm.type == 2">
                <el-select
                    filterable
                    allow-create
                    default-first-option
                    v-model="ruleForm.hospital_department"
                            placeholder="请选择科室"
                            style="width:100%;">
                    <el-option
                        v-for="item in allDeparment "
                        :key="item.department_name"
                        :label="item.department_name"
                        :value="item.department_name"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="职称" v-if="ruleForm.type == 2">
                <el-select v-model="ruleForm.title_id" placeholder="请选择职称"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allTitle "
                        :key="item.id"
                        :label="item.title_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="秘书姓名" v-if="ruleForm.type == 1">
                <el-input type="text" v-model="ruleForm.assistant_user_name" placeholder="请输入秘书姓名" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="秘书手机号码" v-if="ruleForm.type == 1">
                <el-input type="text" v-model="ruleForm.assistant_mobile" placeholder="请输入秘书手机号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="头像" prop="user_avatar">
                <div class="avatar-uploader">
                    <label class="avatar-btn avatar" for="uploads">
                        <img style=" width: 200px;height: 200px;" v-if="userAvaratImageUrl" :src="userAvaratImageUrl"
                             class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </label>
                </div>
                <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
            </el-form-item>
            <el-form-item label="身份证照片">
                <div>
                    <div style="float: left;margin-left: 2px;">
                        <el-input type="hidden" v-model="ruleForm.idcard_img_up" placeholder="身份证正面照片"
                                  style="width: 100%;"></el-input>
                        <el-upload
                            class="avatar-uploader"
                            accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG"
                            :action="upload_path"
                            :show-file-list="false"
                            :on-success="handleIdCartUpImgSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img style=" width: 316px;height: 200px;" v-if="idcartUpImageUrl" :src="idcartUpImageUrl"
                                 class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div>请上传jpg/png格式的身份证正面照片<i class="el-icon-zoom-in"  @click="previewImage(idcartUpImageUrl, '身份证正面照片')" v-if="idcartUpImageUrl"></i></div>
                    </div>
                    <div style="float: left;margin-left: 20px;">
                        <el-input type="hidden" v-model="ruleForm.idcard_img_down" placeholder="身份证反面照片"
                                  style="width: 100%;"></el-input>
                        <el-upload
                            class="avatar-uploader"
                            accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG"
                            :action="upload_path"
                            :show-file-list="false"
                            :on-success="handleIdCartDownImgSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img style=" width: 316px;height: 200px;" v-if="idcartDownImageUrl" :src="idcartDownImageUrl"
                                 class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <div>请上传jpg/png格式的身份证反面照片</div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="身份证号码">
                <el-input type="text" v-model="ruleForm.id_card" maxlength="18" placeholder="请输入身份证号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="银行卡照片" v-if="ruleForm.type == 2">
                <el-input type="hidden" v-model="ruleForm.bankcard_img" placeholder="银行卡照片"
                          style="width: 100%;"></el-input>
                <el-upload
                    class="avatar-uploader"
                    :action="upload_path"
                    :show-file-list="false"
                    :on-success="handleBankCartImgSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img style=" width: 316px;height: 200px;" v-if="bankcartImageUrl" :src="bankcartImageUrl"
                         class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div>请上传jpg/png格式的银行卡照片<i class="el-icon-zoom-in" @click="previewImage(bankcartImageUrl, '银行卡照片')" v-if="bankcartImageUrl"></i></div>
            </el-form-item>
            <el-form-item label="银行卡号" v-if="ruleForm.type == 2">
                <el-input type="text" v-model="ruleForm.bank_card" @change="bankChange" placeholder="请输入银行卡号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="银行卡开户行" v-if="ruleForm.type == 2">
                <el-input type="text" v-model="ruleForm.bank_name" placeholder="请输入银行卡开户行" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">待审</el-radio>
                    <el-radio :label="2">通过</el-radio>
                    <el-radio :disabled="true" :label="3">被拒</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="修改意见" v-if="ruleForm.status == 3">
                <el-select v-model="ruleForm.message_content" style="width: 80%;" multiple placeholder="请选择修改意见">
                    <el-option
                        v-for="item in checkMessageDoctor"
                        :key="item.message"
                        :label="item.message"
                        :value="item.message"
                        v-if="ruleForm.type == '2'"
                    >
                    </el-option>
                    <el-option
                        v-for="item in checkMessageUser"
                        :key="item.message"
                        :label="item.message"
                        :value="item.message"
                        v-if="ruleForm.type == '1'"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="头像裁剪" :visible.sync="dialogVisible" append-to-body @close="closeDialog">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :autoCrop="true"
                        :fixed="true"
                        :fixedNumber="[1, 1]">
                    </vue-cropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <label class="el-button el-button--primary" for="suploads" style="margin-right: 10px;"><span>重新选择</span></label>
                <input type="file" id="suploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                <el-button type="primary" @click="uploadImg('blob')" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="preview_title" :visible.sync="previewImageVisible">
            <div class="image_box" >
                <el-image :src="previewImageUrl"></el-image>
            </div>
        </el-dialog>


    </div>

</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {VueCropper} from "vue-cropper";
import {fileType, isMobile} from "@/api/order";
import pdf from "vue-pdf";

export default {
    components: {
        VueCropper,
        pdf
    },
    created() {
        if (isMobile()) {
            this.form_min_width = "none"
            this.form_width = "100%"
        }
        localStorage.setItem('prev_page', 'apply_edit')
        this.id = this.$route.params.id || '';
        if (this.id > 0) {
            this.getDetail()
        }
    },
    mounted() {

    },
    data() {
        return {
            id:'',
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            upload_agreement_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
            userAvaratImageUrl: '',
            idcartUpImageUrl: '',
            idcartDownImageUrl: '',
            bankcartImageUrl: '',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            user_id: '',
            preview_title: '',
            previewImageVisible: false,
            previewImageUrl: '',
            ruleForm: {
                user_name: "",
                mobile: "",
                user_avatar: "",
                sex: 1,
                age: "",
                type: "",
                status: 1,
                company_name: "",
                position: "",
                hospital_department: "",
                id_card: "",
                address: "",
                bank_card: "",
                bank_name: "",
                title_id: "",
                photos: [],
                other: [],
                idcard_img_up: '',
                idcard_img_down: '',
                bankcard_img: '',
                assistant_user_name: '',
                assistant_mobile: '',
                message_content:[],
            },
            rules: {
                company_name: [
                    {required: true, message: "请选择所在单位", trigger: "blur"},
                ],
            },
            dialogVisible: false,
            // 防止重复提交
            loading: false,
            option: {
                img: '',             //裁剪图片的地址
            },
            allCompany: [],
            allDeparment: [],
            allTitle: [],
            allType: [
                {
                    id: 1,
                    name: '特属服务对象',
                },
                {
                    id: 2,
                    name: '特属专家',
                },
            ],
            checkMessageUser:[
                {message:'您的身份证信息识别有误，请重新上传！'},
                {message:'您的单位名称不符合要求！'},
                {message:'您的职务名称不符合要求！'},
            ],
            checkMessageDoctor:[
                {message:'您的身份证信息识别有误，请重新上传！'},
                {message:'您的银行卡信息识别有误，请重新上传！'},
                {message:'您的单位名称不符合要求！'},
                {message:'您的职务名称不符合要求！'},
            ],
            form_width: "40%",
            form_min_width: "810px"
        };
    },
    methods: {
        getFileType(url) {
            return fileType(url)
        },
        // 所有咨询者，专家
        getDetail() {

            if (this.user_id != '') {
                this.expertDetail();
            }
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'getApplyDetail',
                params: {
                    id: this.id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                let data = res.data.data;
                this.ruleForm.user_name = data.user_name;
                this.ruleForm.mobile = data.mobile;
                this.ruleForm.sex = parseInt(data.sex);
                this.ruleForm.age = parseInt(data.age);
                // this.ruleForm.status = parseInt(data.status);
                this.ruleForm.status = 2;
                this.ruleForm.type = parseInt(data.type);
                this.ruleForm.company_name = data.company_name;
                this.ruleForm.position = data.position;
                this.ruleForm.hospital_department = data.hospital_department;
                this.ruleForm.id_card = data.id_card;
                this.ruleForm.address = data.address;
                this.ruleForm.bank_card = data.bank_card;
                this.ruleForm.bank_name = data.bank_name;
                this.ruleForm.title_id = data.title_id;
                this.ruleForm.message_content = data.remark;
                if (res.data.data.user_avatar) {
                    this.userAvaratImageUrl = this.imgUrl + res.data.data.user_avatar;
                    this.ruleForm.user_avatar = res.data.data.user_avatar;
                }
                if (data.photos) {
                    let photos = data.photos
                    for (let i = 0; i < photos.length; i++) {
                        switch (parseInt(photos[i].type)) {
                            case 1:
                                this.ruleForm.idcard_img_up = photos[i].url
                                this.idcartUpImageUrl = this.imgUrl + photos[i].url
                                if (!data.id_card) {
                                    this.imageOcr(1, photos[i].url)
                                }
                                break;
                            case 2:
                                this.ruleForm.idcard_img_down = photos[i].url
                                this.idcartDownImageUrl = this.imgUrl + photos[i].url
                                break;
                            case 3:
                                this.ruleForm.bankcard_img = photos[i].url
                                this.bankcartImageUrl = this.imgUrl + photos[i].url
                                if (!data.bank_card || !data.bank_name) {
                                    this.imageOcr(2, photos[i].url)
                                }
                                break;
                        }
                    }
                }
                if (data.other && data.other[0]) {
                    let other = data.other
                    this.ruleForm.assistant_user_name = other[0].user_name||''
                    this.ruleForm.assistant_mobile = other[0].mobile||''
                }
                this.createParams()
            });

        },
        yearChange(e) {
            this.ruleForm.working_year = parseInt(e)
        },
        createParams() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'createParams',
                params: {
                    type: this.ruleForm.type
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompany = res.data.data.allCompany;
                if (this.ruleForm.type == 2) {
                    this.allDeparment = res.data.data.allDepartment
                    this.allTitle = res.data.data.allTitle;
                }

            });
        },
        imageOcr(type, imageUrl) {
            let params = {
                servername: 'Ruyi_basic_services',
                method: 'get_ocr_info',
                params: {
                    type: type,
                    image: imageUrl,
                    is_admin: 1,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                switch (parseInt(type)) {
                    case 1:
                        if (res.data.data.idcard) {
                            this.ruleForm.id_card = res.data.data.idcard
                        }
                        if (res.data.data.address) {
                            this.ruleForm.address = res.data.data.address
                        }
                        if (res.data.data.real_name) {
                            this.ruleForm.user_name = res.data.data.real_name
                        }
                        if (res.data.data.sex) {
                            this.ruleForm.sex = parseInt(res.data.data.sex)
                        }
                        if (res.data.data.age) {
                            this.ruleForm.age = parseInt(res.data.data.age)
                        }
                        break;
                    case 2:
                        if (res.data.data.bank_card_number) {
                            this.ruleForm.bank_card = res.data.data.bank_card_number
                        }
                        if (res.data.data.bank_name) {
                            this.ruleForm.bank_name = res.data.data.bank_name
                        }
                        break;
                }
            });
        },
        bankChange(bank_card) {
            if (this.ruleForm.bankcard_img)return;
            let params = {
                servername: 'Ruyi_basic_services',
                method: 'get_ocr_info',
                params: {
                    type: 3,
                    bank_card: bank_card,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.ruleForm.bank_name = res.data.data.bank_name
            });
        },

        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;
        },

        // 提交表单
        submitForm(formName) {
            this.ruleForm.photos = []
            if (this.ruleForm.idcard_img_up) {
                this.ruleForm.photos.push({
                    type: 1,
                    url: this.ruleForm.idcard_img_up,
                })
            }
            if (this.ruleForm.idcard_img_down) {
                this.ruleForm.photos.push({
                    type: 2,
                    url: this.ruleForm.idcard_img_down,
                })
            }
            if (this.ruleForm.bankcard_img) {
                this.ruleForm.photos.push({
                    type: 3,
                    url: this.ruleForm.bankcard_img,
                })
            }
            this.ruleForm.other = []
            if (this.ruleForm.assistant_user_name && !this.ruleForm.assistant_mobile) {
                this.$message({
                    type: "error",
                    message: "请填写秘书手机号码",
                });
                return;
            }
            if (!this.ruleForm.assistant_user_name && this.ruleForm.assistant_mobile) {
                this.$message({
                    type: "error",
                    message: "请填写秘书姓名",
                });
                return;
            }
            if (this.ruleForm.assistant_user_name && this.ruleForm.assistant_mobile) {
                this.ruleForm.other.push({
                    user_name: this.ruleForm.assistant_user_name,
                    mobile: this.ruleForm.assistant_mobile,
                })
            }
            let method = 'editApply'
            let message = '编辑成功'
            if (!this.id) {
                method = 'addApply'
                message = '添加成功'
            }
            let _that = this

            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (parseInt(this.ruleForm.status) === 2 && !this.ruleForm.id_card) {
                        this.$confirm(`${this.ruleForm.user_name}的身份证号未填写，是否通过审核？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(()=>{
                            this.doApply(method, message)
                        }).catch(() => {
                        });
                    } else {
                        this.doApply(method, message)
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    return false;
                }
            });
        },
        async doApply(method, message) {
            let _that = this
            let params = {
                'servername': 'Ruyi_AdminCustomerServices',
                'method': method,
                'params': {
                    id: this.id,
                    user_name: this.ruleForm.user_name,
                    mobile: this.ruleForm.mobile,
                    sex: this.ruleForm.sex,
                    age: this.ruleForm.age,
                    type: this.ruleForm.type,
                    status: this.ruleForm.status,
                    company_name: this.ruleForm.company_name,
                    position: this.ruleForm.position,
                    hospital_department: this.ruleForm.hospital_department,
                    id_card: this.ruleForm.id_card,
                    address: this.ruleForm.address,
                    bank_card: this.ruleForm.bank_card,
                    bank_name: this.ruleForm.bank_name,
                    title_id: this.ruleForm.title_id,
                    photos: this.ruleForm.photos,
                    other: this.ruleForm.other,
                    user_avatar: this.ruleForm.user_avatar,
                    remark: this.ruleForm.message_content
                }
            };
            await this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                if (!res.code) {
                    this.$message({
                        type: "success",
                        message: message,
                        duration: 1500,
                        onClose: function () {
                            _that.is_submit = false;
                            window.history.go(-1);
                            return;
                        }
                    });
                }
            }).catch(()=>{
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 上传头像图片
        handleUserAvatarImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.user_avatar = res.data;
                this.userAvaratImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传身份证图片
        handleIdCartUpImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.idcard_img_up = res.data;
                this.idcartUpImageUrl = this.imgUrl + res.data;
                this.imageOcr(1, res.data)
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传身份证图片
        handleIdCartDownImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.idcard_img_down = res.data;
                this.idcartDownImageUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 上传银行卡图片
        handleBankCartImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.bankcard_img = res.data;
                this.bankcartImageUrl = this.imgUrl + res.data;
                this.imageOcr(2, res.data)
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        // 除去图片
        handleRemove(file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        addFileList.push(name);
                    }
                }
            }
            this.addFileList = addFileList;
        },
        // 上传图片成功
        handleSuccess(response, file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        if (fileList[i].response.data.file) {
                            addFileList.push(fileList[i].response.data);
                        } else {
                            addFileList.push({
                                file: fileList[i].response.data
                            });
                        }
                    }
                }
            }

            this.addFileList = addFileList;
            this.ruleForm.file = "file";
        },
        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            console.log('beforeAvatarUpload', file)
            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png格式!');
            }
            return isJPG;
        },

        //选择图片
        selectImg(e) {
            let file = e.target.files[0]

            if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                this.$message({
                    message: '图片类型要求：jpeg、jpg、png',
                    type: "error"
                });
                return false
            }
            //转化为blob
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                this.option.img = data
                this.dialogVisible = true;
            }
            //转化为base64
            reader.readAsDataURL(file)
        },
        //上传头像图片
        uploadImg(type) {
            let _this = this;
            if (type === 'blob') {
                //获取截图的blob数据
                this.$refs.cropper.getCropBlob(async (data) => {

                    let formData = new FormData();
                    formData.append('file', data, ".jpg")

                    await _this.$api.avatar_upload_file(formData).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code == 0) {
                            _this.ruleForm.user_avatar = res.data.data;
                            _this.userAvaratImageUrl = this.imgUrl + res.data.data;
                            _this.dialogVisible = false;
                        } else {
                            _this.$message({
                                type: "error",
                                message: res.data.msg,
                            });
                        }
                    })

                })
            }
        },
        // 关闭对话框清除之前选择的文件
        closeDialog() {
            document.getElementById('uploads').value = ''
            document.getElementById('suploads').value = ''
        },
        // 预览图片
        previewImage(url, title){
            this.previewImageUrl = url
            this.preview_title = title
            this.previewImageVisible = true;
        },
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.cropper-content {
    .cropper {
        width: auto;
        height: 300px;
    }
}

.avatar-btn, .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-btn {
    display: inline-block;
    text-align: center;
}

.avatar-btn, .avatar-uploader .el-upload:hover {
    border-color: #d9d9d9;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar-btn {
    width: 200px;
    height: 200px;
}

.avatar{
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
}

.avatar-btn.avatar{
    width: 200px;
    height: 200px;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}
.el-icon-zoom-in {
    cursor: pointer;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
